import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { SttSplashScreen, SttNotificationScreen, MateriaisSuporte } from '@stt-componentes/core-v3';
import { SttHelpdeskShortcut } from '@stt-componentes/core';
import { SttUserHeader, SttTranslateHook } from '@stt-componentes/core-v2';
import { getHeaders } from '../requests/index';
import { useSignal, useSignals } from '@preact/signals-react/runtime';
import { usuarioSignal } from '../signals/usuario';
import { Funcionalidade } from '@stt-console/util';

const Menu = () => {
    useSignals();
    const navigate = useNavigate();
    const location = useLocation();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const submenus = useSignal([]);
    const tabAtual = useSignal(0);
    const openSS = useSignal(false);
    const openMS = useSignal(false);
    const exibirNotificacao = useSignal(false);

    useEffect(() => {
        let menuOptions = [];
        const rbac = usuarioSignal.value.rbac;
        if (!rbac.temPermissao(Funcionalidade.MODULO) && !rbac.ehAdminParceiroRestrito()) {
            navigate(`/nao-autorizado`);
            return;
        }

        exibirNotificacao.value = true;

        if (usuarioSignal.value.rbac.temPermissao(Funcionalidade.PAGINA_CREDENCIAIS)) {
            menuOptions = [
                ...menuOptions,
                {
                    id: '/credenciais',
                    text: strings.credenciais,
                    button: true,
                    onClick: () => {
                        navigate('/credenciais');
                    },
                },
            ];
        }

        if (usuarioSignal.value.rbac.temPermissao(Funcionalidade.PAGINA_MODULOS)) {
            menuOptions = [
                ...menuOptions,
                {
                    id: '/modulos',
                    text: strings.modulos,
                    button: true,
                    onClick: () => {
                        navigate('/modulos');
                    },
                },
            ];
        }

        if (rbac.temPermissao(Funcionalidade.PAGINA_PARCEIROS) || rbac.ehAdminParceiroRestrito()) {
            menuOptions = [
                ...menuOptions,
                {
                    id: '/parceiros',
                    text: strings.parceiros,
                    button: true,
                    onClick: () => {
                        navigate('/parceiros');
                    },
                },
            ];
        }

        submenus.value = menuOptions;
    }, []);

    useEffect(() => {
        submenus.value.forEach((menu, i) => {
            if (location.pathname.includes(menu.id)) {
                tabAtual.value = i;
            }
        });
    }, [location]);

    return (
        <>
            <SttUserHeader
                nomeUsuario={usuarioSignal.value?.nome || ''}
                config={global.gConfig}
                strings={strings}
                headers={getHeaders()}
                opcoesDuvida={{
                onClickNotasAtualizacao: () => (openSS.value = !openSS.value),
                onClickMateriaisSuporte: () => (openMS.value = !openMS.value),
                }}
                submenus={submenus.value}
                selectedTab={tabAtual.value}
            />

            <SttSplashScreen
                modulo={global.gConfig.modulo_nome}
                versao={global.gConfig.modulo_versao}
                novidades={global.gConfig.modulo_novidades}
                textoAjuda={global.gConfig.texto_ajuda}
                perfisRBAC={usuarioSignal.value.perfisRBAC}
                open={openSS.value}
                setOpen={(open) => { openSS.value = open }}
            />
            <MateriaisSuporte
                strings={strings}
                config={global.gConfig}
                headers={getHeaders()}
                open={openMS.value}
                setOpen={(open) => { openMS.value = open }}
            />
            {
                exibirNotificacao.value &&
                <SttNotificationScreen
                    config={global.gConfig}
                    strings={strings}
                    headers={getHeaders()}
                    perfisRBAC={usuarioSignal.value.perfisRBAC}
                />
            }
            <SttHelpdeskShortcut
                config={global.gConfig}
                usuario={usuarioSignal.value}
            />
        </>
    );
};

export default Menu;
